import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalState } from "../Context/GlobalStateContext";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";

function CompanyList() {
  const navigate = useNavigate();
  const globalState = useGlobalState();
  const [loadingState, setLoadingState] = useState(false);
  const [companyListData, setcompanyListData] = useState<any>([]);

  useEffect(() => {
    getCompanyForSelection();
  }, []);
  function getCompanyForSelection() {
    let object = {} as any;
    setLoadingState(true);
    axiosAuth
      .post(
        AppContext.AppAuthBaseURL + "api/SiteUser/GetCompanyForSelection",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data.Data;
          setcompanyListData(l_response[0]);
          console.log(l_response);
        }
        setLoadingState(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  function setCompanySelection(cid: any) {
    let object = {} as any;
    object.cid = cid;
    // setLoadingState(true);
    axiosAuth
      .post(
        AppContext.AppAuthBaseURL + "api/SiteUser/SetCompanySelection",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data.Data;
          navigate("/tools");
          //   setcompanyListData(l_response[0]);
          console.log(l_response);
        }
        // setLoadingState(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  return (
    <div className="app-main">
      {loadingState && <LoadingAnimation />}
      <div className="apps-inn">
        {companyListData &&
          companyListData.map((Item: any, index: number) => (
            <React.Fragment key={index}>
              <a
                className={"c-" + (index + 1)}
                title={Item.Description}
                // href={Item.WebURL}
                onClick={() => setCompanySelection(Item.PRPCompanyID)}
              >
                <span className="a-inn">
                  <img
                    src={Item.LogoImageURL}
                    width="17px"
                    height="15px"
                    alt={Item.Name}
                  />
                  <span>{Item.Description}</span>
                </span>
              </a>
            </React.Fragment>
          ))}
      </div>
    </div>
  );
}

export default CompanyList;
